import { put, call, take, fork } from 'redux-saga/effects'
import { patchCollectionSettingsService } from '../../api/collection'
import { patchCollectionSettingsSuccess } from '../../reducers/collection/action'
import { PATCH_COLLECTION_SETTINGS } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* patchCollectionSettingFlow(payload) {
  const { content, callback, onError } = payload

  try {
    yield call(patchCollectionSettingsService, content)

    yield put(patchCollectionSettingsSuccess(content))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))

    // Callers that moved their own state ahead of the write get to undo it.
    if (onError) onError(error)
  }
}

/**
 *
 */
export default function* patchCollectionSettingWatcher() {
  while (true) {
    const action = yield take(PATCH_COLLECTION_SETTINGS)
    const { payload } = action

    yield fork(generalSaga, patchCollectionSettingFlow, payload, false)
  }
}
